import { LegalLayout } from "./components/legalLayout";
import { OMBUDSMAN_DOC } from "./content/ombudsman";

/** /ouvidoria — canal independente para reclamações não resolvidas e denúncias. */
export const Ouvidoria = () => <LegalLayout document={OMBUDSMAN_DOC} />;
